import { useState } from "react";
import { Button, Modal, ModalFooter } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import styles from "./styles/style.module.scss";

export default function ModalWrapperBtn({
    fullscreen = false,
    size = "",
    title,
    btnText,
    handleSave,
    children,
    closeBtn = true,
}) {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    // if (!isOpen) return <Button onClick={handleOpen}>{btnText}</Button>;

    return (
        <>
            <Button
                className={`${isOpen ? "opacity-50" : ""} ${
                    styles["modal-button"]
                }`}
                onClick={handleOpen}
            >
                {btnText}
            </Button>
            <Modal
                className={styles["modal-container"]}
                size={size}
                show={isOpen}
                fullscreen={fullscreen}
                onHide={handleClose}
            >
                <Modal.Header closeButton>
                    <h5>{title}</h5>
                </Modal.Header>
                <Modal.Body>{children}</Modal.Body>
                <ModalFooter>
                    <Button
                        color="info"
                        onClick={() => {
                            handleSave();
                            handleClose();
                        }}
                    >
                        <FormattedMessage id="done" />
                    </Button>
                    {closeBtn && (
                        <Button
                            color="danger"
                            onClick={handleClose}
                            className="me-3"
                        >
                            <FormattedMessage id="cancel" />
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
        </>
    );
}
